module.exports = __webpack_public_path__ + "img/2-1.895b7a7a.jpg";